import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { Switch as ChakraSwitch } from '@chakra-ui/react';
const SwitchFC = ({ checked, onChange, ...props }) => {
    return (_jsxs(ChakraSwitch.Root, { size: 'md', checked: checked, onCheckedChange: (e) => onChange(e.checked), ...props, children: [_jsx(ChakraSwitch.HiddenInput, {}), _jsx(ChakraSwitch.Control, { children: _jsx(ChakraSwitch.Thumb, {}) })] }));
};
export const Switch = memo(SwitchFC);
//# sourceMappingURL=Switch.js.map